module.exports = __webpack_public_path__ + "img/content12.a26fe6cd.png";